import styled, { css } from "styled-components";

const semanticTokens = {
  padding: "1.2rem 1.4rem",
};

export interface StyledWrapProps {
  disabled?: boolean;
}

export const WrapStyle = styled.div`
  min-width: 29rem;
  position: relative;
  text-align: center;
`;

export const InputWrap = styled.div<StyledWrapProps & { filled?: boolean }>`
  background: ${({ theme }) => theme.color.background.white};
  width: 100%;
  height: 4.8rem;
  padding: ${semanticTokens.padding};
  border: 0.1rem solid ${({ theme }) => theme.color.stroke.light};
  border-radius: 0.5rem;
  box-sizing: border-box;
  color: ${({ theme }) => theme.color.text.placeholder};
  cursor: pointer;

  display: inline-flex;
  align-items: center;

  svg {
    color: ${({ theme }) => theme.color.text.tertiery};
  }

  /* status: disabled */
  ${({ theme, disabled }) =>
    disabled
      ? css`
          background: ${theme.color.background.default};
          color: ${theme.color.text.disabled};
          cursor: not-allowed;
        `
      : css`
          /* status: hover */
          &:hover {
            ${({ theme }) => css`
              border-color: ${theme.color.stroke.dark};
              color: ${theme.color.text.secondary};

              svg {
                color: ${theme.color.text.secondary};
              }
            `}
          }
        `}

  /* status: filled */
  ${({ theme, filled }) =>
    filled &&
    css`
      &,
      &:hover {
        color: ${theme.color.text.default};
      }
    `}
`;

export const Date = styled.div<{ isPlaceholder: boolean }>`
  flex: 1;
  ${({ theme }) => theme.typography.body1.regular}
  ${({ isPlaceholder, theme }) =>
    isPlaceholder && `color: ${theme.color.text.placeholder};`}
`;

export const DocumentInputWrap = styled.div`
  display: flex;
  gap: 1rem;

  p {
    display: flex;
    height: 5.6rem;
    align-items: center;
  }
`;
